'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var isDOMNodeInView = exports.isDOMNodeInView = function isDOMNodeInView(domNode) {
    var rect = domNode.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};

var stopPropagationOnly = exports.stopPropagationOnly = function stopPropagationOnly(event) {
    return event.stopPropagation();
};

var selectAndCopyInput = exports.selectAndCopyInput = function selectAndCopyInput(event) {
    event.target.setSelectionRange(0, event.target.value.length);
    document.execCommand('copy');
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/domUtil.js
// module id = 107
// module chunks = 0